import consumer from './consumer';

/**
 * S'abonne au fil d'un sujet de messagerie (une tâche, une action de projet
 * réseau). Le type et l'identifiant sont portés par le DOM, jamais écrits ici.
 */
export function createChatSubscription(subjectType, subjectId, callbacks) {
  return consumer.subscriptions.create(
    { channel: 'ChatChannel', subject_type: subjectType, subject_id: subjectId },
    callbacks
  );
}
